function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-6-5h24v24H-6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2276E3",
  fillRule: "nonzero",
  d: "M6.345 14.399l-.114-.003a.864.864 0 01-.637-1.354l3.95-5.678a.288.288 0 000-.329l-3.95-5.68A.864.864 0 017.013.37l3.949 5.678c.479.692.479 1.61 0 2.302l-3.95 5.678a.864.864 0 01-.781.367zm-5.77-.288a.576.576 0 01-.472-.902l3.95-5.678a.579.579 0 000-.66L.103 1.193A.576.576 0 01.576.288h1.928c.188 0 .365.092.472.247l3.95 5.678c.411.594.411 1.38 0 1.973l-3.95 5.678a.576.576 0 01-.472.247z"
}));

function SvgRightDoubleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 15"
  }, props), _ref);
}

export default SvgRightDoubleArrow;